import { PortalProvider } from '../contexts/PortalContext';
import { DemNotificationsProvider } from '../contexts/DemNotificationsContext';
import type { PortalKind } from '../lib/portal';
import { RequireAuth } from './RequireAuth';
import { RequirePortalChoice } from './RequirePortalChoice';
import { DemAppShell } from './layout/DemAppShell';

export function DemPortalApp({ kind }: { kind: PortalKind }) {
  return (
    <PortalProvider kind={kind}>
      <RequireAuth>
        <RequirePortalChoice>
          <DemNotificationsProvider>
            <DemAppShell />
          </DemNotificationsProvider>
        </RequirePortalChoice>
      </RequireAuth>
    </PortalProvider>
  );
}
